import createLogger from './createLogger';

const generalLogger = createLogger({ prefix: 'General', prefixColor: '#FFDC00' });
const socketLogger = createLogger({ prefix: 'Socket', prefixColor: '#7FDBFF' });
const httpLogger = createLogger({ prefix: 'HTTP', prefixColor: '#0074D9' });
const mixpanelLogger = createLogger({ prefix: 'Mixpanel', prefixColor: '#eb7ab1' });
const stateLogger = createLogger({ prefix: 'Routing', prefixColor: '#444' });

export default generalLogger;

export {
    httpLogger,
    socketLogger,
    mixpanelLogger,
    stateLogger,
};



// WEBPACK FOOTER //
// ./scripts/common/services/logging/loggers.js